export default "__VITE_ASSET__DPbxmqoz__"